import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-big-block-details',
  templateUrl: './big-block-details.component.html',
  styleUrls: ['./big-block-details.component.css']
})
export class BigBlockDetailsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
